// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @actions
const expectedProfitabilityActions = require('../../actions/RAExpectedProfitability');
const raCustomPlanByObjectiveActions = require('../../actions/RACustomPlanByObjective');
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const raSuitabilityTestActions = require('../../actions/RASuitabilityTest');
const raTimeHorizonCheckActions = require('../../actions/RATimeHorizonCheck');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');
const raSimulationActions = require('../../actions/RASimulation');
const raPortfoliosNameHistoryActions = require('../../actions/RAPortfoliosNameHistory');

// @utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getNumOfDaysBetweenDates } = require('utilities/dateHelper');

const {
    RA_PROJECTION_CHART_ALL_PRODUCTS,
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
} = require('../../raConstants/index');

const FREQ_BY_PERIODICITY = {
    [CONTRIBUTION_PERIOD_DAILY]: 365,
    [CONTRIBUTION_PERIOD_WEEKLY]: 52,
    [CONTRIBUTION_PERIOD_MONTHLY]: 12,
};

// @constants
const { RA_NO_STRATEGY_SELECTED } = require('../../raConstants/index');

class RAGoalWrapperView extends React.Component {
    componentDidMount() {
        this.props.requestPortfolioDistribution();
        this.props.getPDFContract(this.props.history);
        this.fetchStrategies();
        this.props.getTestResult();
        this.props.getDisplayNames();
        this.props.requestSimulation().then(() => {
            this.props.getSimulation();
            this.props.timeHorizonCheck(() => {}, this.shortStrategyNumber);
        });
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const { immCustomPlanByObjective, immSimulation } = this.props;
        const prevObjectiveEndDate = prevProps.immCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const objectiveEndDate = immCustomPlanByObjective.get(
            'objectiveEndDate',
        );

        if (
            immSimulation.get('success') &&
            !!objectiveEndDate &&
            !objectiveEndDate.isSame(prevObjectiveEndDate)
        ) {
            this.props.timeHorizonCheck(() => {}, this.shortStrategyNumber);
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetMaxTypeOfProduct();
    }

    fetchStrategies() {
        const { requestProjectionChart, immCustomPlanByObjective } = this.props;
        const initialContributionAmount = immCustomPlanByObjective.get(
            'initialContributionAmount',
        );
        const recurringContributionAmount = immCustomPlanByObjective.get(
            'recurringContributionAmount',
        );
        const objectiveEndDate = immCustomPlanByObjective.get(
            'objectiveEndDate',
        );
        const periodicity = immCustomPlanByObjective.get('periodicity');
        const contributionDay = immCustomPlanByObjective.get('contributionDay');

        if (
            initialContributionAmount == null ||
            initialContributionAmount === '' ||
            periodicity === '' ||
            recurringContributionAmount == null ||
            !objectiveEndDate
        ) {
            return;
        }

        const nDays = Math.abs(getNumOfDaysBetweenDates(objectiveEndDate));
        const chartYears = nDays / 365;
        const freq = FREQ_BY_PERIODICITY[periodicity] || 1;
        if (
            recurringContributionAmount >= 1 &&
            freq === CONTRIBUTION_PERIOD_MONTHLY
        ) {
            requestProjectionChart({
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: initialContributionAmount,
                freq,
                mntPayment: recurringContributionAmount,
                cutDay: contributionDay,
            });
        } else {
            requestProjectionChart({
                dataPoints: 2,
                chartYears,
                product: RA_PROJECTION_CHART_ALL_PRODUCTS,
                balance: initialContributionAmount,
                freq,
                mntPayment: recurringContributionAmount,
            });
        }
    }

    shortStrategyNumber() {
        const { immTimeHorizonCheck, immCustomPlanByObjective } = this.props;
        const maxTypeOfProduct = immTimeHorizonCheck.get('maxTypeOfProduct');
        const selectedStrategy = immCustomPlanByObjective.get(
            'selectedStrategy',
        );

        if (
            maxTypeOfProduct < selectedStrategy &&
            selectedStrategy !== RA_NO_STRATEGY_SELECTED
        ) {
            this.props.setSelectedStrategy(RA_NO_STRATEGY_SELECTED);
        }
    }

    render() {
        return this.props.children;
    }
}

RAGoalWrapperView.propTypes = {
    children: PropTypes.any,
    getPDFContract: PropTypes.func.isRequired,
    getDisplayNames: PropTypes.func.isRequired,
    getSimulation: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    immSimulation: PropTypes.object.isRequired,
    immTimeHorizonCheck: PropTypes.object.isRequired,
    requestPortfolioDistribution: PropTypes.func.isRequired,
    requestProjectionChart: PropTypes.func.isRequired,
    requestSimulation: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetMaxTypeOfProduct: PropTypes.func.isRequired,
    setSelectedStrategy: PropTypes.func.isRequired,
    timeHorizonCheck: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        immSimulation: state.raSimulation,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
    }),
    {
        getDisplayNames: raPortfoliosNameHistoryActions.getDisplayNames,
        getSimulation: raCustomPlanByObjectiveActions.getSimulation,
        getPDFContract: raHireManagementPlanActions.getPDFContract,
        getTestResult: raSuitabilityTestActions.getTestResult,
        requestProjectionChart:
            expectedProfitabilityActions.requestProjectionChart,
        requestSimulation: raSimulationActions.requestSimulation,
        reset: raCustomPlanByObjectiveActions.reset,
        resetMaxTypeOfProduct: raTimeHorizonCheckActions.resetMaxTypeOfProduct,
        requestPortfolioDistribution:
            portfolioDistributionActions.requestPortfolioDistribution,
        setSelectedStrategy: raCustomPlanByObjectiveActions.setSelectedStrategy,
        timeHorizonCheck: raTimeHorizonCheckActions.timeHorizonCheck,
    },
)(withRouter(RAGoalWrapperView));
